'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAwayMessage = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAwayMessage = exports.getAwayMessage = function getAwayMessage(config) {
  return (0, _get2.default)('awayMessage', config) || '';
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/availability/operators/config/getAwayMessage.js
// module id = 704
// module chunks = 2 3